import * as Sentry from '@sentry/nuxt'
import { isChunkLoadError, isKeepAliveTeardownError, installChunkErrorWatchers, triggerChunkReloadOnce } from '~/utils/chunkErrors'

export default defineNuxtPlugin((nuxtApp) => {
    installChunkErrorWatchers()

    let navigationCount = 0

    nuxtApp.hook('page:finish', () => {
        navigationCount++
        if (navigationCount === 1) {
            Sentry.setTag('user_navigated_after_reload', 'true')
        }
        Sentry.setTag('session_nav_count', String(navigationCount))
    })

    nuxtApp.hook('app:chunkError', ({ error }) => {
        console.warn('Error in chunk:', error)
        triggerChunkReloadOnce(error)
    })

    nuxtApp.hook('app:error', (error) => {
        console.error('Global error:', error)
        if (isChunkLoadError(error)) {
            console.warn('Component/chunk error detected.')
            triggerChunkReloadOnce(error)
        } else if (isKeepAliveTeardownError(error)) {
            console.warn('KeepAlive teardown bug detected (vuejs/core#10415).')
            triggerChunkReloadOnce(error)
        }
    })
})
